import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WebHome             from './pages/WebHome';
import WebBeReady          from './pages/WebBeReady';
import WebHistorias        from './pages/WebHistorias';
import WebHistoriaDetalle  from './pages/WebHistoriaDetalle';
import WebFeedback         from './pages/WebFeedback';
import { WebAcademy, WebAcademyCourse, WebAcademyTester, WebNosotros, WebContacto, WebHireMeDeep, WebHireMeBridge, Web404 } from './pages/WebPages';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/"                element={<WebHome />}            />
        <Route path="/beready"         element={<WebBeReady />}         />
        <Route path="/historias"       element={<WebHistorias />}       />
        <Route path="/historias/:id"   element={<WebHistoriaDetalle />} />
        <Route path="/feedback"        element={<WebFeedback />}        />
        <Route path="/academy"         element={<WebAcademy />}         />
        <Route path="/academy/ai-tester" element={<WebAcademyTester />} />
        <Route path="/academy/:slug"   element={<WebAcademyCourse />}   />
        <Route path="/nosotros"        element={<WebNosotros />}        />
        <Route path="/contacto"        element={<WebContacto />}        />
        <Route path="/hiremedeep"      element={<WebHireMeDeep />}      />
        <Route path="/hiremebridge"    element={<WebHireMeBridge />}    />
        <Route path="*"               element={<Web404 />}            />
      </Routes>
    </Router>
  );
}
